import { Component, ElementRef, OnInit, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { diffDays } from '@fullcalendar/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, PrimeNGConfig, SelectItem } from 'primeng/api';
import { InputNumber } from 'primeng/inputnumber';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { EnderecoService } from '../../endereco/endereco.service';
import { FornecedorListComponent } from '../../fornecedor/fornecedor-list/fornecedor-list.component';
import { Fornecedor } from '../../fornecedor/models/fornecedor';
import { Pedido, PedidoEvento } from '../../pedido/models/pedido';
import { PedidoProduto } from '../../pedido/models/pedido-produto';
import { Endereco } from '../../pessoa/models/endereco';
import { Pessoa } from '../../pessoa/models/pessoa';
import { PessoaService } from '../../pessoa/pessoa.service';
import { EventoService } from '../evento.service';
import { Evento, EventoProduto, EventoProdutoEvento, FormaPagamento, Parcela } from '../models/evento';
import {v4 as uuidv4} from 'uuid';
import { UserService } from 'src/app/core/services/user.service';
import { AttachSession } from 'protractor/built/driverProviders';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DatePipe } from '@angular/common';
import { ParametrizacaoService } from '../../parametrizacao/parametrizacao.service';
import { Parametro } from '../../parametrizacao/models/parametrizacao';
import { UsuarioService } from '../../usuario/usuario.service';
import { Usuario } from '../../usuario/models/usuario';

@Component({
  selector: 'app-evento-pedido-detail',
  templateUrl: './evento-pedido-detail.component.html',
  styleUrls: ['./evento-pedido-detail.component.scss'], 
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None
})
export class EventoPedidoDetailComponent implements OnInit {


  parametros: Parametro[];

  produtos: EventoProdutoEvento[];

  
  produto: EventoProdutoEvento;
  pedido:PedidoEvento;
  pedidoProdutos:PedidoProduto[]=[];
  guidPedido = uuidv4();
  evento: Evento;

  idFormaPagamento:number;

  vendedores: Usuario[];
   vendedor?: Usuario;

  enderecos:Endereco[];
  endereco:Endereco;
  cobrarFrete: boolean = true;

  quantidade: number;
  desconto: number;

  fornecedores: Fornecedor[];
  fornecedoresVinculados: Fornecedor[];
  items: SelectItem[];
  selectedCountry: any;
  idEvento:string;
  fornecedor : Fornecedor;
  fornecedorAnterior : Fornecedor;
  isDisabled:boolean=true;

  parcelas: Parcela[];
  parcelaSelecionada: Parcela;
  parcela: Parcela;

  formasPagamento:FormaPagamento[];
  formaPagamentoSelecionada:FormaPagamento;

  pessoa: Pessoa;
  mat: string;
  cpf: string;

  temParcelas:boolean = false;
  aPrazo:boolean = false;
  aVista:boolean = false;
  boleto:boolean = false;
  polpaCitrica:boolean = false;
  antecipado:boolean = false;
  dataParcela:Date;
  dataEntrega:Date;

  atributo: string;
  valorDesconto: number=0.00;
  valorFrete: number=0.00;
  valorChapa: number=0.00;
  valorNectar: number=0.00;
  valorTotalProdutos: number=0.00;
  valorTotalGeral: number=0.00;
  valorParcela: number=0.00;
  taxaJuros: number=0;
  qtdeParcelas: number=2;
  valorTotalPedido: number=0.00;
  pesoCarga: number=0;
  obsVendedor: string;

  taxaJurosReal: number=1;
  
  public pt = {
    firstDayOfWeek: 0,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho','Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };

  
  @ViewChild("myinput") myInputField: ElementRef;

  constructor(private eventoService:EventoService, 
              private pessoaService: PessoaService,
              private notificationsService: NotificationsService,
              private confirmationService: ConfirmationService,
              private enderecoService:EnderecoService,
              public userService: UserService,
              private translateService: TranslateService,
              private config: PrimeNGConfig,
              private router: Router, 
              private datePipe: DatePipe,
              private parametrizacaoService: ParametrizacaoService,
              private usuarioService: UsuarioService,
    private _Activatedroute: ActivatedRoute)
     {
   // this.fornecedor = {} as Fornecedor;

   console.log(this.guidPedido)

   translateService.setDefaultLang('pt');
   this.dataParcela = new Date();
   this.dataEntrega = new Date();
 
   // the lang to use, if the lang isn't available, it will use the current loader to get them
   translateService.use('pt');

   //console.log(this.parcelas);

   let agora: Date = new Date();
   console.log(agora.getMonth());

  }




  ngOnInit(): void {

    this.config.setTranslation(this.pt);
    this.evento = this._Activatedroute.snapshot.data['Evento']; 
    this._Activatedroute.paramMap.subscribe(params => {
      if (params.has('idEvento')) {
        this.idEvento = params.get('idEvento');

        this.getFornecedoresVinculados();
        this.getParametrosEvento();
        
      }
    });

    if(!this.evento.flAtivo){
      this.notificationsService.toastNotify("warn","Alerta!","Evento encerrado.")
      this.router.navigate(['/evento/'+ this.idEvento+'/pedido-list']) 
    }

    this.getVendedores();
    
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
}

  onKeypressEvent(event: any){

    if(event.keyCode ===13){
      this.buscarCliente();
    }
    //console.log(event);

  }

  onKeypressQTD(event: any){

    if(event.keyCode ===13){
      this.addProduto();
    }
    //console.log(event);

  }
  getParametro(nomeParametro: string){
    return this.parametros.find(k => k.nome.toLowerCase()==nomeParametro.toLowerCase()).valor;
  }

  getParametrosEvento() {

    

    this.parametrizacaoService.getParametrosEvento(Number.parseInt( this.idEvento)).subscribe(
      (res) => {
        if (res) {
          this.parametros = res;  
          console.log(res);     
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Parametros");
        console.log(err);
      }
    );
  } 


  getFornecedoresVinculados() {

    

    this.eventoService.getFornecedoresUsuarioVinculados().subscribe(
      (res) => {
        if (res) {
          this.fornecedoresVinculados = res;    
          this.getFornecedores();     
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Fornecedor");
        console.log(err);
      }
    );
  } 

  getFornecedores() {

    

    this.eventoService.getFornecedores(this.idEvento).subscribe(
      (res) => {
        if (res) {
          if(this.fornecedoresVinculados.length==0){
          this.fornecedores = res;         
          }else{
            let forn:Fornecedor[] = res;
            this.fornecedores=[];
            forn.forEach(element => {
              if(this.fornecedoresVinculados.filter(obj => obj.idFornecedor === element.idFornecedor).length>0){
                this.fornecedores.push(element)
              }
            });
          }
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Fornecedor");
        console.log(err);
      }
    );
  } 

  buscarCliente(){
    if(!this.cpf && !this.mat){
        this.notificationsService.toastNotify("warn","Alerta!","Ou o CPF ou a matrícula devem ser informadas.")
    }else{
      if(this.cpf){
        this.cpf=this.cpf.replace("-","");
        this.cpf=this.cpf.replace(".","");
        this.getPessoaByCPF(this.cpf);
        this.cpf=null;
      }else{
        this.getPessoaByMat(this.mat);
        this.mat=null;
      }
    }
  }

  getFormaPagamento(idEventoFornecedor) {

    this.eventoService.getFormasPagamentoEventoFornecedor(idEventoFornecedor).subscribe(
      (res) => {
        if (res) {
          this.formasPagamento = res;         
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Formas Pagamento");
        console.log(err);
      }
    );
  } 

  getPessoaByCPF(cpf:string) {

    this.pessoaService.getPessoaByCPF(cpf).subscribe(
      (res) => {
        if (res) {
          this.pessoa = res;  
          this.setCliente();
          console.log(this.pessoa);       
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - pessoa CPF");
        console.log(err);
      }
    );
  } 

  getPessoaByMat(mat:string) {

    this.pessoaService.getPessoaByMat(mat).subscribe(
      (res) => {
        if (res) {
          this.pessoa = res;   
          this.setCliente();
          console.log(this.pessoa);      
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - pessoa MAT");
        console.log(err);
      }
    );
  } 


  getEndereco(idPessoa) {

    this.enderecoService.getEnderecoByPessoa(idPessoa).subscribe(
      (res) => {
        if (res) {
          this.endereco = null;
          this.enderecos = res;   
          this.enderecos.forEach(element => {
            element.enderecoCompleto = element.endereco+' - '+element.cidade
          });
          console.log(this.enderecos)     
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Endereco");
        console.log(err);
      }
    );
  } 

  getVendedores(){
    this.usuarioService.getUsuarios().subscribe(
      (res) => {
        if (res) {
          this.vendedor = null;
          this.vendedores = res;   
          this.vendedores = this.vendedores.filter(
  k => k.perfil?.includes('Vendedor') || k.perfil?.includes('Vendedor Interno')
);
         // this.vendedores.forEach(element => {
          //  element.enderecoCompleto = element.endereco+' - '+element.cidade
          //});
          console.log(this.vendedores)     
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Vendedor");
        console.log(err);
      }
    );

  }

  onChangeCobrarFrete(e){
    //console.log(e)
    //this.cobrarFrete= e.checked;
    this.calcularValores();
  
  }

  isAPrazoOk(){
    debugger;
    if(!this.formaPagamentoSelecionada.cdFormaPagamento.includes('PRAZO')){
      return true;
    }
    let dtLimite = new Date(this.fornecedor.dtLimitePrazo);
    
    let dat_adubos :string = this.parametros.find(k => k.nome=="DATA_MAX_PGTO_PRAZO_EXCECOES").valor;
    let codi :string = this.parametros.find(k => k.nome=="DATA_MAX_PGTO_PRAZO_EXCECOES").codProduto;
    let data:Date= new Date(this.dataParcela);
    let ok = true;
    let pr = null;
    for(var l = 0;l<this.pedidoProdutos.length;l++) {

      let dt_limite = this.fornecedores.find(k => k.idEventoFornecedor == this.pedidoProdutos[l].idEventoFornecedor  ).dtLimitePrazo.toString()
      let data_limite:Date= new Date(Number.parseInt(dat_adubos.split("-")[0]),Number.parseInt(dat_adubos.split("-")[1])-1,Number.parseInt(dat_adubos.split("-")[2]),0,0,0,0);
      let dta_limite:Date= new Date(Number.parseInt(dt_limite.split("-")[0]),Number.parseInt(dt_limite.split("-")[1])-1,Number.parseInt(dt_limite.split("-")[2]),0,0,0,0);

      if(codi.includes(this.pedidoProdutos[l].cdInterno)){
        if(data_limite.getTime()<data.getTime()){
          ok= false;
          break;
        }else{
          ok= true;
        }
        

      }else{
        if(dta_limite.getTime()<data.getTime()){
          ok= false;
          break;
        }else{
          ok= true;
        }
      }
    }

    

  return ok;
    



    
  }

  isDataPolpaOk(){
    let data:Date= new Date(this.dataParcela);

    if(this.polpaCitrica){
      let dtEntrega = new Date(this.dataEntrega);
      //dtLimitePolpa.setDate(dtLimitePolpa.getDate()+45);
      if((data.getTime()-dtEntrega.getTime()) >4838400000){
        return false
      }else{
        return true
      }
    }else{
      return true;
    }
    return true
  }




  isDataMaxEntregaOk(pedidoProduto:PedidoProduto){

    console.log('---------teste-----')
    console.log(this.evento.dtLimiteEntrega)
    let dtEntregalimite = new Date(this.evento.dtLimiteEntrega);
    let data:Date= new Date(this.dataEntrega);


    let datas  = this.parametros.filter(k => k.nome.indexOf("DATA_MAX_")>=0 &&  k.nome.indexOf("DATA_MAX_PGTO")<0 
    &&  k.nome.indexOf("DATA_MAX_FORNECEDORES_EXCECAO")<0 
    &&  k.nome.indexOf("DATA_MAX_ENTREGA_PRODUTOS_DIFERENCIADOS")<0)

    console.log(datas)

    let ok =false;
    for(let par of datas){
      console.log(par)
      let dat_adubos :string = par.valor;
      let codi :string = par.codProduto;
      let dataMaxAdubos:Date= new Date(Number.parseInt(dat_adubos.split("-")[0]),Number.parseInt(dat_adubos.split("-")[1])-1,Number.parseInt(dat_adubos.split("-")[2]),0,0,0,0);
       
      
      if(codi?.includes(pedidoProduto.cdInterno)){
        console.log('---------codigo bateu-----')


        if(dataMaxAdubos.getTime()<data.getTime()){
          ok= false;
          
        }else{
          ok= true;
          return true;

        }
        

      }else if((par?.idFornecedor??0) == pedidoProduto?.idFornecedor){
        console.log('---------fornecedor bateu-----')
        let ok =true;

        if(dataMaxAdubos.getTime()<data.getTime()){
          ok= false;
        }else{
          return true;
        }
        

      }


    }

     return ok;

  }

  

  isEntregaOk(){

    console.log('teste-----')
    console.log(this.evento.dtLimiteEntrega)
    let dtEntregalimite = new Date(this.evento.dtLimiteEntrega);
    let data:Date= new Date(this.dataEntrega);
    let dat :string = this.parametros.find(k => k.nome=="DATA_MAX_ENTREGA_PRODUTOS_DIFERENCIADOS").valor;
    let dat_adubos :string = this.parametros.find(k => k.nome=="DATA_MAX_ADUBOS_DEFENSIVOS_SEMENTES").valor;
    let codi :string = this.parametros.find(k => k.nome=="DATA_MAX_ADUBOS_DEFENSIVOS_SEMENTES").codProduto;

    

    let fornnn :string = this.parametros.find(k => k.nome=="DATA_MAX_FORNECEDORES_EXCECAO").valor;
    
    let dataMax:Date= new Date(Number.parseInt(dat.split("-")[0]),Number.parseInt(dat.split("-")[1])-1,Number.parseInt(dat.split("-")[2]),0,0,0,0);

    let ok =true;
    for(var l = 0;l<this.pedidoProdutos.length;l++) {
      console.log("data")
      let nomeFornecedor = this.fornecedores.find(k => k.idEventoFornecedor == this.pedidoProdutos[l].idEventoFornecedor  ).nomeFornecedor
      console.log(nomeFornecedor)

      
      

      let dataMaxAdubos:Date= new Date(Number.parseInt(dat_adubos.split("-")[0]),Number.parseInt(dat_adubos.split("-")[1])-1,Number.parseInt(dat_adubos.split("-")[2]),0,0,0,0);

    /*  if(fornnn.includes(nomeFornecedor)){
        if(dataMax.getTime()<data.getTime()){
          ok= false;
          break;
        }else{
          ok= true;
        }
        

      }else*/
    
      if(!this.isDataMaxEntregaOk(this.pedidoProdutos[l]) ){
          ok= false;
          if(dtEntregalimite.getTime()<data.getTime()){
            ok= false;
            break;
          }else{
            ok= true;
          }
         

      }
      
      
     }

     return ok;

   /* if(['EXZOLT','BOOSTIN','LACTOTROPIN E POSILAC','DELAVAL'].includes(this.fornecedor.nomeFornecedor)){
       let dat :string = this.parametros.find(k => k.nome=="DATA_MAX_ENTREGA_PRODUTOS_DIFERENCIADOS").valor;
       let dataMax:Date= new Date(Number.parseInt(dat.split("-")[2]),Number.parseInt(dat.split("-")[1]),Number.parseInt(dat.split("-")[0]),0,0,0,0);
       

      console.log(dataMax)
      if(dataMax.getTime()<data.getTime()){
        return false;
      }else{
        return true;
      }

    }else if(this.antecipado){
      let dat :string = this.parametros.filter(k => k.nome=="DATA_MAX_ANTECIPADO").map(m=> m.valor)[0];

      let dataMax:Date= new Date(Number.parseInt(dat.split("-")[2]),Number.parseInt(dat.split("-")[1]),Number.parseInt(dat.split("-")[0]),0,0,0,0);
      if(dataMax.getTime()<data.getTime()){
        return false;
      }else{
        return true;
      }
    }else{
      if(dtEntregalimite.getTime()<data.getTime()){
        return false;
      }else{
        return true;
      }
    }*/
  }

  isEntregaParcelaOk(){

    if(!this.formaPagamentoSelecionada.cdFormaPagamento.includes('PARCELADO')){
      return true;
    }
    if(!this.dataEntrega && !this.dataParcela){
      return true;
    }

    let dataEnt:Date= new Date(this.dataEntrega);
    let dataParc:Date= new Date(this.dataParcela);

   
      let dtEnt1 =new Date(2022, 8, 19,0,0,0,0)
        let dtEnt2 =new Date(2022, 9, 19,0,0,0,0)

        let dtParc1 =new Date(2022, 10, 1,0,0,0,0)
        let dtParc2 =new Date(2022, 11, 1,0,0,0,0)
        if(dataEnt.getTime()<=dtEnt1.getTime()){
          if(dataParc.getTime()>dtParc1.getTime()){
          this.notificationsService.toastNotify("warn","Alerta!","A da Primeira parcela não pode ser superior 31-10-2022 para data de entrega menor que 19-09-2022!" )
            return false
          }
        }

        if(dataEnt.getTime()<=dtEnt2.getTime()){
          if(dataParc.getTime()>dtParc2.getTime()){
            this.notificationsService.toastNotify("warn","Alerta!","A da Primeira parcela não pode ser superior 30-11-2022 para data de entrega menor que 19-10-2022!" )
            return false
          }
        }
  
        return true;
  }


  
  isDataLimiteDeParcelasOk(){
    // console.log("isQuantidadeDeParcelasOk")
     if(!this.formaPagamentoSelecionada.cdFormaPagamento.includes('PARCELADO')){
       return true;
     }
     if( !this.dataParcela){
      return true;
    }
    let dtParcela = this.dataParcela
    let pr :PedidoProduto =null

    console.log(dtParcela)
     
     console.log("isDataLimiteDeParcelasOk")



     let i =this.parcelaSelecionada.qtd-1;

     for(var k = 0;k<this.pedidoProdutos.length;k++) {
      console.log("data")
      console.log(this.pedidoProdutos[k])
      
      let dtLimite = new Date(this.pedidoProdutos[k].dtLimite);

      console.log(this.pedidoProdutos[k].dtLimite)
      console.log(dtParcela)
        let data:Date= new Date(dtParcela);
        let data2:Date= new Date(dtParcela);
        console.log("isDataLimiteDeParcelasOk0")
        data2.setMonth(data2.getMonth()+i);
        console.log("isDataLimiteDeParcelasOk1")
       
        if((((data.getMonth()+i)%12)+1)==2 ){
          if(data2.getFullYear()%4!==0){
            if(data.getDate()>28){
              data.setDate(28)
            }
          }else{
            if(data.getDate()>29){
              data.setDate(29)
            }
          }
        }
        console.log("isDataLimiteDeParcelasOk2")
  
        if((((data.getMonth()+i)%12)+1)==4 ||(((data.getMonth()+i)%12)+1)==6 || (((data.getMonth()+i)%12)+1)==9 ||(((data.getMonth()+i)%12)+1)==11){
          
            if(data.getDate()>30){
              data.setDate(30)
            }
          
        }
        data.setMonth(data.getMonth()+i);
  
        

        console.log(dtLimite)
        console.log(data)
    
        if(dtLimite.getTime()<data.getTime()){
          pr = this.pedidoProdutos[k];
          break;
        }
 
     }; 

     if(pr){
      this.notificationsService.toastNotify("warn","Alerta!","A última parcela do produto "+pr.nomeProduto+" não pode ser superior à " +this.datePipe.transform(pr.dtLimite,'dd/MM/yyyy'))
  
      return false;
    }
 
     //console.log(max)
     //console.log(this.parcelaSelecionada.qtd)
 
     console.log("isQuantidadeDeParcelasOk4")
 
 
 
     return true;
 
   }

  isQuantidadeDeParcelasOk(){
   // console.log("isQuantidadeDeParcelasOk")
    if(!this.formaPagamentoSelecionada.cdFormaPagamento.includes('PARCELADO')){
      return true;
    }
    console.log("isQuantidadeDeParcelasOk2")
    this.parcelaSelecionada.qtd;
    let max = 99;
    let pr = null;

    console.log(this.pedidoProdutos)
    console.log(this.produtos)
    this.pedidoProdutos.forEach(function (value) {
      console.log("teste teste")
      console.log(value)
      
     //let m =  this.produtos.filter(obj => obj.idEventoProduto == value.idEventoProduto);
     //console.log(this.produtos.filter(obj => obj.idEventoProduto === value.idEventoProduto))
     console.log(max)
     console.log(value.maxParcelas??0)
     if((value.maxParcelas??0)< max){
      max = value.maxParcelas??0;
      pr = value;
     }

     console.log(max)
     console.log(value.maxParcelas??0)
     console.log("isQuantidadeDeParcelasOk3")
 

    }); 

    console.log(max)
    console.log(this.parcelaSelecionada.qtd)

    console.log("isQuantidadeDeParcelasOk4")

    if(this.parcelaSelecionada.qtd > max){
      this.notificationsService.toastNotify("warn","Alerta!","O produto " +pr.nomeProduto+" só pode ser parcelado em "+max+" vezes.")
      //this.parcelaSelecionada = this.parcelas[0];
      return false
    }

    return true;

  }

  isParcelasOk(){
    if(!this.formaPagamentoSelecionada.cdFormaPagamento.includes('PARCELADO')){
      return true;
    }
    if(!this.isQuantidadeDeParcelasOk()){
        return false;
    }
    if(!this.isDataLimiteDeParcelasOk()){
      return false;
  }
    

    return this.isEntregaParcelaOk();

    let i =this.parcelaSelecionada.qtd-1;
      
    let dtLimite = new Date(this.fornecedor.dtLimite);
      let data:Date= new Date(this.dataParcela);
      let data2:Date= new Date(this.dataParcela);
      data2.setMonth(data2.getMonth()+i);

     
      if((((data.getMonth()+i)%12)+1)==2 ){
        if(data2.getFullYear()%4!==0){
          if(data.getDate()>28){
            data.setDate(28)
          }
        }else{
          if(data.getDate()>29){
            data.setDate(29)
          }
        }
      }

      if((((data.getMonth()+i)%12)+1)==4 ||(((data.getMonth()+i)%12)+1)==6 || (((data.getMonth()+i)%12)+1)==9 ||(((data.getMonth()+i)%12)+1)==11){
        
          if(data.getDate()>30){
            data.setDate(30)
          }
        
      }
      data.setMonth(data.getMonth()+i);

  
      if(dtLimite.getTime()<data.getTime()){
        return false;
      }else{
        return true;
      }
    

  }



  getProdutos(idEventoFornecedor) {

    this.eventoService.getProdutosFornecedor(idEventoFornecedor).subscribe(
      (res) => {
        if (res) {
          this.produtos = res;         
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Formas Pagamento");
        console.log(err);
      }
    );
  } 

  setCliente(){
    if(this.pessoa.flCooperado){
      this.atributo = 'COOPERADO'
    }else{
      this.atributo = 'CLIENTE'
    }

    this.getEndereco(this.pessoa.idPessoa);
    this.calcularPagamento();

   
  }

  

  onDropDownPagamentoChange(event){

    console.log(event)

    if(event.value.cdFormaPagamento.includes("PARCELADO")){
      this.temParcelas=true;
    }else{
      this.temParcelas=false;
    }

    if(event.value.cdFormaPagamento.includes("PRAZO")){
      this.aPrazo=true;
    }else{
      this.aPrazo=false;
    }

    if(event.value.cdFormaPagamento.includes("VISTA")){
      this.aVista=true;
    }else{
      this.aVista=false;
    }

    if(event.value.cdFormaPagamento.includes("BOLETO")){
      this.boleto=true;
    }else{
      this.boleto=false;
    }
    
    if(event.value.cdFormaPagamento.includes("ANTECIPADO")){
      this.antecipado=true;
    }else{
      this.antecipado=false;
    }
    this.idFormaPagamento = event.value.idFormaPagamento;
    this.calcularValores();
   // this. calcularPagamento();

  }
  onDataParcelaChange(event){
    if(!this.isParcelasOk()){
      //this.notificationsService.toastNotify("warn","Alerta!","A última parcela não pode ser superior à " +this.datePipe.transform(this.fornecedor.dtLimite,'dd/MM/yyyy'))
      return;
    }
    if(!this.isAPrazoOk()){
      this.notificationsService.toastNotify("warn","Alerta!",this.parametros.find(k => k.nome=="MENSAGEM_PGTO_PRAZO").valor);
      //this.notificationsService.toastNotify("warn","Alerta!","O pagamento não pode ser superior à " +this.datePipe.transform(this.fornecedor.dtLimitePrazo,'dd/MM/yyyy'))
      return;
    }
    this.calcularPagamento();
    console.log("change")
  }

  onDataEntregaChange(event){

    if(!this.isEntregaOk()){

      let dat :string = this.parametros.find(k => k.nome=="DATA_MAX_ENTREGA_PRODUTOS_DIFERENCIADOS").valor;
    let dataMax:Date= new Date(Number.parseInt(dat.split("-")[0]),Number.parseInt(dat.split("-")[1])-1,Number.parseInt(dat.split("-")[2]),0,0,0,0);
      this.notificationsService.toastNotify("warn","Alerta!",this.parametros.find(k => k.nome=="MENSAGEM_ENTREGA_MAXIMA").valor
      
      )
      
    }

    this.calcularPagamento();

  }

  onDropDownParcelasChange(event){
    try {
      
    
      if(this.parcelaSelecionada.qtd<=1){
        this.notificationsService.toastNotify("warn","Alerta!","A quantidade de parcelas deve ser maior que 1.")
        return;
      }
      if(!this.isParcelasOk()){
        //this.notificationsService.toastNotify("warn","Alerta!","A última parcela não pode ser superior à " +this.datePipe.transform(this.fornecedor.dtLimite,'dd/MM/yyyy'))
        return;
      }
      this. calcularPagamento();
  } catch (error) {
      
  }
  }

  onDropDownFornecedorChange(event){
    if(event.value!=null){
      console.log(this.pedidoProdutos)
      if(this.pedidoProdutos.length>0){
        this.confirmTrocarFornecedor(event.value);
      }else{
        this.fornecedorAnterior = this.fornecedor;
        
          this.getProdutos(event.value.idEventoFornecedor);
          this.getFormaPagamento(event.value.idEventoFornecedor);

          this.parcelas=[];
          this.produto=null;
          this.produtos=[];

          //this.parcela = {nome:'1 Parcela', qtd:1};
          //this.parcelas.push(this.parcela);
          //getParametro('NUM_PARCELAS_COMBO')

          let parc = this.fornecedor.nomeFornecedor =="COOPER"?Number.parseInt(this.getParametro('NUM_PARCELAS_COMBO')):this.fornecedor.qtMaxParcelas;

          for (let i = 2; i <=parc/*this.fornecedor.qtMaxParcelas*/; i++) {
            this.parcela = {nome:i+' Parcelas', qtd:i};
            this.parcelas.push(this.parcela);
          }

          this.parcelaSelecionada = this.parcelas[0];
  
      }

    }

    
  }

  confirmTrocarFornecedor(fornecedor: Fornecedor){


      this.confirmationService.confirm({
          message: 'Você tem certeza que deseja trocar de Fornecedor? As informações desse pedido serão pedidas!',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              this.pedidoProdutos=[]
              this.valorChapa=0;
              this.valorFrete=0;
              this.valorNectar=0;
              this.valorTotalPedido=0;
              this.valorTotalProdutos=0;
              this.valorTotalGeral=0;
              this.notificationsService.toastNotify("success","Sucesso!","Forncedor Alterado!")
              this.getProdutos(fornecedor.idEventoFornecedor);
              this.getFormaPagamento(fornecedor.idEventoFornecedor);
              this.parcelas=[];
              let parc = this.fornecedor.nomeFornecedor =="COOPER"?Number.parseInt(this.getParametro('NUM_PARCELAS_COMBO')):this.fornecedor.qtMaxParcelas;
              for (let i = 2; i <=parc/*this.fornecedor.qtMaxParcelas*/; i++) {
                this.parcela = {nome:i+' Parcelas', qtd:i};
                this.parcelas.push(this.parcela);
              }

              this.parcelaSelecionada = this.parcelas[0];
              this.produto=null;
              this.produtos=[];
  
          },
          reject: () => {
            this.fornecedor = this.fornecedorAnterior;
          }
      });
  
  }

  onDropDownProdutoChange(event){
    console.log(event)
    //console.log(this.myInputField)
    //this.myInputField.first.input.nativeElement.focus();
    //console.log(this.myInputField)
  }

  onDropDownEnderecoChange(event){
    if(this.fornecedor){
      this.calcularValores();
    }
  }

  editProduto(item){
    this.produto = this.produtos.filter(obj => obj.idProdutoOriginal === item.idProduto)[0];
    this.quantidade = item.quantidade;
    this.pedidoProdutos= this.pedidoProdutos.filter(obj => obj.idProduto !== item.idProduto);
    this.calcularValores();
  }

  deleteItem(item){
    this.pedidoProdutos= this.pedidoProdutos.filter(obj => obj.idProduto !== item.idProduto);
    this.calcularValores();
  }

  addProduto(){
    if(!this.quantidade || this.quantidade<=0){
      this.notificationsService.toastNotify("warn","Alerta!","A quantidade precisa ser informada.")
      return;
    }

    let prod=this.pedidoProdutos.filter(obj => obj.idProduto === this.produto.idProdutoOriginal)[0];
    if(prod!==undefined){
      this.notificationsService.toastNotify("info","Pedido!","Foi adicionado "+this.quantidade+" "+this.produto.unidadeMedida+" à quantidade existente!")
      
      prod.quantidade+=this.quantidade;
      prod.vlDesconto += (this.desconto??0)*this.quantidade;
      this.quantidade=null;
      this.desconto = null;
     this.produto=null;
      this.calcularValores();
      return
    }
   

    let pedidoProduto:PedidoProduto = {} as PedidoProduto;

    console.log(this.produto);

    pedidoProduto.vlCustoProduto = this.produto.vlPrecoCusto;
    pedidoProduto.idProduto = this.produto.idProdutoOriginal;
    pedidoProduto.nomeProduto = this.produto.nomeProduto;
    pedidoProduto.cdInterno = this.produto.cdInterno;
    pedidoProduto.quantidade = this.quantidade;
    pedidoProduto.vlDesconto = (this.desconto??0)*this.quantidade;
    pedidoProduto.peso = this.produto.peso;
    pedidoProduto.vlUnitario = this.produto.vlEvento;
    pedidoProduto.vlEvento = this.produto.vlEvento;
    pedidoProduto.unidadeMedida = this.produto.unidadeMedida;
    pedidoProduto.vlTotal = this.produto.vlEvento*this.quantidade;
    pedidoProduto.vlPrecoNectar = this.produto.vlPrecoNectar;
    pedidoProduto.flFrete = this.produto.flFrete;
    pedidoProduto.flChapa = this.produto.flChapa;
    pedidoProduto.idEventoProduto = this.produto.idEventoProduto;
    pedidoProduto.maxParcelas = this.produto.maxParcelas;


    pedidoProduto.jurosCooperado = this.produto.jurosCooperado;
    pedidoProduto.jurosPadrao = this.produto.jurosPadrao;
    pedidoProduto.idFornecedor = this.produto.idFornecedor;
    pedidoProduto.dtLimite = this.produto.dtLimite;
    pedidoProduto.idEventoFornecedor = this.produto.idEventoFornecedor;

    if(this.produto.flChapa && this.produto.peso){
      pedidoProduto.vlChapa = ((this.quantidade*this.produto.peso)/1000.0)*this.fornecedor.vlChapaTon;
    }else{
      pedidoProduto.vlChapa =0;
    }
    


    if(this.endereco){

      if(this.fornecedor.flFreteSigeve){
        if(this.produto.flFrete && this.produto.peso){
          if(this.produto.unidadeMedida=='KG'){
            pedidoProduto.vlFrete=((this.quantidade*this.produto.peso*this.endereco.vlFreteGranel)/1000.0);
          }else{
            pedidoProduto.vlFrete=((this.quantidade*this.produto.peso*this.endereco.vlFreteSacaria)/1000.0);
          }
         
        }else{
          pedidoProduto.vlFrete =0;
        }
      }else{
        if(this.produto.flFrete && this.produto.peso){
          pedidoProduto.vlFrete=((this.quantidade*this.produto.peso*this.endereco.distanciaKM)/1000.0)*this.fornecedor.vlFreteKm;
        }else{
          pedidoProduto.vlFrete =0;
        }
      }
      //this.valorFrete +=pedidoProduto.vlFrete
      
      
    }else{
      pedidoProduto.vlFrete =0;
    }
    pedidoProduto.guidPedido = this.guidPedido;
    pedidoProduto.guidPedidoProduto = uuidv4();
    this.pedidoProdutos.push(pedidoProduto);
    this.quantidade=null;
    this.produto=null;

    this.calcularValores();

  }

  onChageDistancia(){

   if(this.fornecedor){
     this.calcularValores();
   }
  }


  calcularValores(){
    this.valorTotalProdutos=0;
    this.valorDesconto =0;
    this.valorFrete = 0;
    this.valorChapa = 0;
    this.valorNectar = 0;
    this.valorParcela =0;
    this.valorTotalGeral =0;
    this.pesoCarga = 0;
    this.pedidoProdutos.forEach(element => {
      this.calcularDesconto(element);
     
      //this.calcularPolpaCitrica(element);
      //this.calcularMadeira(element);
      this.valorTotalProdutos+=element.vlTotal;
      this.pesoCarga+=element.quantidade*(element.peso??0);
      element.vlTotalGeral = element.vlTotal;
    let forn = this.fornecedores.find(x => x.idFornecedor === element.idFornecedor)
    console.log("fornecedores")
    console.log(forn)

      if(element.flChapa && element.peso){
        element.vlChapa=((element.quantidade*element.peso)/1000.0)*forn.vlChapaTon;
      }else{
        element.vlChapa =0;
      }

      
      

     
     

      if(this.endereco){
        if(this.fornecedor.nomeFornecedor=="MADEIRA S&D" ){
          if(this.cobrarFrete){
            element.vlFrete= element.vlTotal*0.05;
            element.vlTotal=element.vlTotal-element.vlFrete;
            element.flFrete =true;
          }else{
            element.vlFrete= element.vlTotal*0.05;
            element.vlTotal=element.vlTotal-element.vlFrete;
            element.vlFrete=0;
            element.flFrete=false;
          }
          
        }else{

        if(forn.flFreteSigeve){
          if(element.flFrete && element.peso){
            if(element.unidadeMedida=='KG'){
              element.vlFrete=((element.quantidade*element.peso*this.endereco.vlFreteGranel)/1000.0);
            }else{
              element.vlFrete=((element.quantidade*element.peso*this.endereco.vlFreteSacaria)/1000.0);
            }
           
          }else{
            element.vlFrete =0;
          }
        }else{
          if(element.flFrete && element.peso){
            element.vlFrete=((element.quantidade*element.peso*this.endereco.distanciaKM)/1000.0)*forn.vlFreteKm;
          }else{
            element.vlFrete =0;
          }
        }
      }
        this.valorFrete +=element.vlFrete
        
        
      }else{
        element.vlFrete =0;
      }

      
      
  
      /*if(this.endereco){
        if(element.flFrete && element.peso){
          element.vlFrete=((element.quantidade*element.peso*this.endereco.distanciaKM)/1000.0)*this.fornecedor.vlFreteKm;
        }else{
          element.vlFrete =0;
        }

        this.valorFrete +=element.vlFrete
        element.vlTotalGeral +=element.vlFrete
        
      }else{
        element.vlFrete =0;
      }*/
      this.valorDesconto += element.vlDesconto??0;
      this.valorChapa +=element.vlChapa;
      element.vlTotalGeral +=element.vlChapa;
      element.vlTotalGeral +=element.vlFrete;
      element.vlTotalGeral -=element.vlDesconto??0;
      this.valorNectar+= element.vlPrecoNectar* element.quantidade;
      this.valorTotalGeral +=element.vlTotalGeral;
      element.vlUnitarioTotal = element.vlTotalGeral/element.quantidade;

      element.vlEconomia = (element.vlPrecoNectar* element.quantidade)-(element.vlTotal+element.vlChapa)
      

    });
    this.valorTotalPedido = this.valorTotalProdutos;
    this. calcularPagamento();
      
  }


  calcularPagamento(){

    this.valorParcela =0;
    this.valorTotalPedido=0;

    /*this.calcularParcelas();
    this.calcularAPrazo();
    this.calcularAVista();
    this.calcularDemais();
    this.calcularValorUnitario();
    */

    this.calcularParcelasUnitario();
    this.calcularAPrazoUnitario();
    //this.calcularValorUnitarioCalculoUnitario();
    this.calcularAVistaUnitario();
    this.calcularDemaisUnitario();
    //this.calcularValorUnitarioCalculoUnitario();


  }

  calcularPolpaCitrica(element: PedidoProduto){
      
    if(!this.fornecedor || !this.pessoa ){
      return
    }


    
    if(element.cdInterno!=="223080019" && element.cdInterno!=="223080005" ){
      return
    }

    this.polpaCitrica = true;

    element.vlTotal = element.vlEvento*element.quantidade;
    if(this.pessoa.flCooperado){
    if(this.antecipado ){
      element.vlTotal =element.vlTotal*0.97;
    }else{

    //}

    //if(this.aPrazo ){
      element.vlTotal =element.vlTotal*0.98;
    }
  }else{
    if(this.antecipado){
      element.vlTotal =element.vlTotal*0.98;
    }else{
    //if(this.aPrazo ){
      element.vlTotal =element.vlTotal*1;
      
    }
  }

  }

  calcularDesconto(element: PedidoProduto){
      
    if(!this.fornecedor || !this.pessoa ){
      return
    }
    
    if(this.idEvento!='4' ){
      return
    }


    element.vlTotal = element.vlEvento*element.quantidade;

    if(this.pessoa.flCooperado){
      if(this.antecipado){
        element.vlTotal =element.vlTotal*1;
      }else{
  
      //if(this.aPrazo ){
        console.log(element.vlTotal)
        console.log(element.vlTotal*0.98)
        element.vlTotal =element.vlTotal*0.98;
        
      }
  
    }else{
      if(this.antecipado){
        element.vlTotal =element.vlTotal*1;
      }else{
      //if(this.aPrazo ){
        element.vlTotal =element.vlTotal*1;
        
      }
    }
    
  }

  calcularMadeira(element: PedidoProduto){
      
    if(!this.fornecedor || !this.pessoa ){
      return
    }
    
    if(this.idEvento!='3' ){
      return
    }

    if(this.fornecedor.nomeFornecedor!="MADEIRA S&D" ){
      return
    }


    element.vlTotal = element.vlEvento*element.quantidade;

    if(this.pessoa.flCooperado){
      if(this.aVista){
        element.vlTotal =element.vlTotal*(0.97);
      }
  
      if(this.aPrazo ){
        element.vlTotal =element.vlTotal*(0.99);
        
      }
  
    }else{
      if(this.aVista){
        element.vlTotal =element.vlTotal*(0.98);
      }
      if(this.aPrazo ){
        element.vlTotal =element.vlTotal*(1);
        
      }
    }
    
  }

  calcularValorUnitario(){
    this.pedidoProdutos.forEach(element => {
      element.vlTotalGeralComJuros=  element.vlTotalGeral*this.taxaJurosReal;
      element.vlUnitarioTotal = element.vlTotalGeralComJuros/element.quantidade;
      
      element.vlJuros = element.vlTotalGeralComJuros - element.vlTotalGeral;
    });
  }

  calcularValorUnitarioCalculoUnitario(){
    this.pedidoProdutos.forEach(element => {
      //element.vlTotalGeralComJuros=  element.vlTotalGeral*this.taxaJurosReal;
     // element.vlUnitarioTotal = element.vlTotalGeralComJuros/element.quantidade;
      
      element.vlJuros = element.vlTotalGeralComJuros - element.vlTotalGeral;
    });
  }


  calcularAVistaUnitario(){
      
    if(!this.dataParcela || !this.fornecedor || !this.pessoa || !this.aVista){
      return
    }

    this.taxaJuros = 0;
    let valorTotal = this.valorTotalProdutos+this.valorFrete+this.valorChapa -this.valorDesconto;
    this.valorTotalPedido  = valorTotal;

    this.pedidoProdutos.forEach(element => {
      element.vlTotalGeralComJuros = element.vlTotalGeral;
      element.vlJuros =0;
      element.vlUnitarioTotal = element.vlTotalGeralComJuros/element.quantidade;
    });

    this.taxaJurosReal = 1;
    this.taxaJurosReal = this.taxaJuros;
  }

  calcularAVista(){
      
    if(!this.dataParcela || !this.fornecedor || !this.pessoa || !this.aVista){
      return
    }

    this.taxaJuros = 0;
    let valorTotal = this.valorTotalProdutos+this.valorFrete+this.valorChapa-this.valorDesconto;
    this.valorTotalPedido  = valorTotal;
    this.taxaJurosReal = 1;
  }

  calcularAPrazoUnitario(){
      
    if(!this.dataParcela || !this.fornecedor || !this.pessoa || !this.aPrazo || !this.dataEntrega){
      return
    }

    let agora: Date = new Date();
    let dtJuros =new Date(2022, 10, 1,0,0,0,0)
    let dtJuros2 =new Date(2022, 11, 1,0,0,0,0)

    agora =new Date(this.dataEntrega.getFullYear(), this.dataEntrega.getMonth(), this.dataEntrega.getDate(),0,0,0,0)
    this.dataParcela =new Date(this.dataParcela.getFullYear(), this.dataParcela.getMonth(), this.dataParcela.getDate(),0,0,0,0)



    let diff = Math.abs(this.dataParcela.getTime() - this.dataEntrega.getTime());
    let diffDays = Math.floor(diff / (1000 * 3600 * 24)); 


    this.pedidoProdutos.forEach(element => {

    this.taxaJuros = this.pessoa.flCooperado?element.jurosCooperado:element.jurosPadrao


    if(this.taxaJuros==0 || (this.dataParcela.getTime() - dtJuros.getTime())<0){
      element.vlTotalGeralComJuros  = element.vlTotalGeral;
      this.taxaJurosReal =1;
    }else if(this.taxaJuros==0 || (this.dataParcela.getTime() - dtJuros2.getTime())<0){
      element.vlTotalGeralComJuros  = element.vlTotalGeral*(1+this.taxaJuros);
      this.taxaJurosReal =1+this.taxaJuros;
    }else{
     element.vlTotalGeralComJuros  = this.fv( this.taxaJuros,diffDays/30.0,element.vlTotalGeral)
    }

      element.vlUnitarioTotal = element.vlTotalGeralComJuros/element.quantidade;
      
      element.vlJuros = element.vlTotalGeralComJuros - element.vlTotalGeral;

      this.valorTotalPedido+=element.vlTotalGeralComJuros;

  });

  console.log(this.valorTotalPedido)
  console.log(this.valorTotalGeral)
  this.taxaJuros = this.valorTotalPedido/this.valorTotalGeral;
  this.taxaJurosReal = this.taxaJuros;
    
  }















  calcularAPrazo(){
      
    if(!this.dataParcela || !this.fornecedor || !this.pessoa || !this.aPrazo){
      return
    }

    let agora: Date = new Date();
    let dtJuros =new Date(2022, 10, 1,0,0,0,0)
    let dtJuros2 =new Date(2022, 11, 1,0,0,0,0)

    agora =new Date(this.dataEntrega.getFullYear(), this.dataEntrega.getMonth(), this.dataEntrega.getDate(),0,0,0,0)
    this.dataParcela =new Date(this.dataParcela.getFullYear(), this.dataParcela.getMonth(), this.dataParcela.getDate(),0,0,0,0)



    let diff = Math.abs(this.dataParcela.getTime() - agora.getTime());
    let diffDays = Math.floor(diff / (1000 * 3600 * 24)); 
    this.taxaJuros = this.pessoa.flCooperado?this.fornecedor.jurosCooperado:this.fornecedor.jurosPadrao
    let valorTotal = this.valorTotalProdutos+this.valorFrete+this.valorChapa-this.valorDesconto;
    console.log(this.valorTotalProdutos)
    console.log(this.valorFrete)
    console.log(this.valorChapa)



    if(this.taxaJuros==0 || (this.dataParcela.getTime() - dtJuros.getTime())<0){
      this.valorTotalPedido  = valorTotal;
      this.taxaJurosReal =1;
    }else if(this.taxaJuros==0 || (this.dataParcela.getTime() - dtJuros2.getTime())<0){
      this.valorTotalPedido  = valorTotal*(1+this.taxaJuros);
      this.taxaJurosReal =1+this.taxaJuros;
    }else{
      console.log(diffDays)
      console.log(this.taxaJuros)
      console.log(valorTotal)
      this.valorTotalPedido  = this.fv( this.taxaJuros,diffDays/30.0,valorTotal)
      this.taxaJurosReal = this.valorTotalPedido/valorTotal;
      console.log(this.taxaJurosReal)
    }
    
    
  }


  calcularParcelasUnitario(){
    if(!this.dataParcela || !this.fornecedor || !this.pessoa || !this.temParcelas ){
      return
    }

    this.valorParcela = 0;

    let agora: Date = new Date();
    let dtParc1 =new Date(2022, 10, 1,0,0,0,0)
    let dtParc2 =new Date(2022, 11, 1,0,0,0,0)
    agora =new Date(this.dataEntrega.getFullYear(), this.dataEntrega.getMonth(), this.dataEntrega.getDate(),0,0,0,0)
    this.dataParcela =new Date(this.dataParcela.getFullYear(), this.dataParcela.getMonth(), this.dataParcela.getDate(),0,0,0,0)

    let diff = Math.abs((this.dataParcela.getTime() - agora.getTime())<0?0:(this.dataParcela.getTime() - agora.getTime()));
    let diffDays = Math.floor(diff / (1000 * 3600 * 24)); 
    console.log(diffDays)

    this.pedidoProdutos.forEach(element => {

    //this.taxaJuros = this.pessoa.flCooperado?this.fornecedor.jurosCooperado:this.fornecedor.jurosPadrao
    this.taxaJuros = this.pessoa.flCooperado?element.jurosCooperado:element.jurosPadrao
    //let valorTotal = this.valorTotalProdutos+this.valorFrete+this.valorChapa;

    /*if(this.dataParcela.getTime()< dtParc1.getTime()){
      element.vlParcela = this.PMT( this.taxaJuros,this.parcelaSelecionada.qtd,-1*element.vlTotalGeral,0,1,0);
   
    }else
    if(this.dataParcela.getTime()< dtParc2.getTime()){
      element.vlParcela = this.PMT( this.taxaJuros,this.parcelaSelecionada.qtd,-1*element.vlTotalGeral,0,0,0);
   
    }else*/
      element.vlParcela = this.PMT( this.taxaJuros,this.parcelaSelecionada.qtd,-1*element.vlTotalGeral,0,1,diffDays/30.0);
    this.valorParcela+=element.vlParcela;
    element.vlTotalGeralComJuros =  element.vlParcela*this.parcelaSelecionada.qtd;
    this.valorTotalPedido+=element.vlTotalGeralComJuros;
    element.vlUnitarioTotal = element.vlTotalGeralComJuros/element.quantidade;

      
      element.vlJuros = element.vlTotalGeralComJuros - element.vlTotalGeral+element.vlDesconto;

      console.log(element.nomeProduto)
      console.log(element.vlDesconto)
      console.log(element.vlUnitarioTotal)
      console.log(element.vlParcela)
      console.log(element.vlTotalGeralComJuros)
      console.log(element.vlTotalGeral)
      console.log(element.vlTotal)
      console.log(element.vlFrete)
      console.log(element.vlChapa)
      console.log("---------")

  });

  this.valorParcela = Number(this.valorParcela.toFixed(2));
    this.valorTotalPedido = this.parcelaSelecionada.qtd*this.valorParcela;
    this.taxaJuros = this.valorTotalPedido/this.valorTotalGeral;
    this.taxaJurosReal = this.taxaJuros;
  //this.valorParcela = Number(this.valorParcela.toFixed(2 ));

 

  }




  calcularParcelas(){
    if(!this.dataParcela || !this.fornecedor || !this.pessoa || !this.temParcelas ){
      return
    }

    let agora: Date = new Date();
    let dtParc1 =new Date(2022, 10, 1,0,0,0,0)
    let dtParc2 =new Date(2022, 11, 1,0,0,0,0)
    agora =new Date(this.dataEntrega.getFullYear(), this.dataEntrega.getMonth(), this.dataEntrega.getDate(),0,0,0,0)
    this.dataParcela =new Date(this.dataParcela.getFullYear(), this.dataParcela.getMonth(), this.dataParcela.getDate(),0,0,0,0)

    let diff = Math.abs((this.dataParcela.getTime() - agora.getTime())<0?0:(this.dataParcela.getTime() - agora.getTime()));
    let diffDays = Math.floor(diff / (1000 * 3600 * 24)); 
    console.log(diffDays)

    this.taxaJuros = this.pessoa.flCooperado?this.fornecedor.jurosCooperado:this.fornecedor.jurosPadrao
    let valorTotal = this.valorTotalProdutos+this.valorFrete+this.valorChapa-this.valorDesconto;

    if(this.dataParcela.getTime()< dtParc1.getTime()){
      this.valorParcela = this.PMT( this.taxaJuros,this.parcelaSelecionada.qtd,-1*valorTotal,0,1,0);
   
    }else
    if(this.dataParcela.getTime()< dtParc2.getTime()){
      this.valorParcela = this.PMT( this.taxaJuros,this.parcelaSelecionada.qtd,-1*valorTotal,0,0,0);
   
    }else
      this.valorParcela = this.PMT( this.taxaJuros,this.parcelaSelecionada.qtd,-1*valorTotal,0,1,diffDays/30.0);
    this.valorParcela = Number(this.valorParcela.toFixed(2));
    this.valorTotalPedido = this.parcelaSelecionada.qtd*this.valorParcela;
    this.taxaJurosReal = this.valorTotalPedido/valorTotal;
  }


  calcularDemaisUnitario(){
      
    if(!this.dataParcela || !this.fornecedor || !this.pessoa || !this.aVista){
      return
    }

    this.taxaJuros = 0;
    let valorTotal = this.valorTotalProdutos+this.valorFrete+this.valorChapa-this.valorDesconto;
    this.valorTotalPedido  = valorTotal;

    this.pedidoProdutos.forEach(element => {
      element.vlTotalGeralComJuros = element.vlTotalGeral;
      element.vlJuros =0;
      element.vlUnitarioTotal = element.vlTotalGeralComJuros/element.quantidade;
    });

    this.taxaJurosReal = 1;
    this.taxaJurosReal = this.taxaJuros;
  }

  calcularDemais(){
    if(!this.dataParcela || !this.fornecedor || !this.pessoa || this.temParcelas || this.aVista || this.aPrazo ){
      return
    }

    this.taxaJuros = 0;
    let valorTotal = this.valorTotalProdutos+this.valorFrete+this.valorChapa-this.valorDesconto;
    this.valorTotalPedido  = valorTotal;
    this.taxaJurosReal = 1;
  }

  closeWindow(){
    this.confirmationService.confirm({
      message: 'Você tem certeza que deseja sair? As informações desse pedido serão descartadas!',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.router.navigate(['/evento/'+ this.idEvento+'/pedido-list']) 
      },
      reject: () => {
        
      }
  });
  }
 
  confirmSalvar(){

    if(!this.isParcelasOk()){
      //this.notificationsService.toastNotify("warn","Alerta!","A última parcela não pode ser superior à " +this.datePipe.transform(this.fornecedor.dtLimite,'dd/MM/yyyy'))
      return;
    }
    this.calcularValores();

    this.pedidoProdutos.forEach(element => {
      if(element.vlUnitarioTotal< element.vlCustoProduto){
        this.notificationsService.toastNotify("warn","Alerta!","Existe uma divergencia nos preços do produto "+element.cdInterno+" - "+element.nomeProduto+", por favor confira o pedido!")
        return;
      }
    });
    
    

    if(!this.fornecedor){
      this.notificationsService.toastNotify("warn","Alerta!","O Fornecedor precisa ser informado.")
      return;
    }

    if(!this.pessoa){
      this.notificationsService.toastNotify("warn","Alerta!","O Cliente precisa ser informado.")
      return;
    }

    if(!this.endereco){
      this.notificationsService.toastNotify("warn","Alerta!","O endereço precisa ser informado.")
      return;
    }

    if(!this.isParcelasOk()){
      //this.notificationsService.toastNotify("warn","Alerta!","A última parcela não pode ser superior à " +this.datePipe.transform(this.fornecedor.dtLimite,'dd/MM/yyyy'))
      return;
    }

    if(!this.isAPrazoOk()){
      this.notificationsService.toastNotify("warn","Alerta!",this.parametros.find(k => k.nome=="MENSAGEM_PGTO_PRAZO").valor);
      //this.notificationsService.toastNotify("warn","Alerta!","O pagamento não pode ser superior à " +this.datePipe.transform(this.fornecedor.dtLimitePrazo,'dd/MM/yyyy'))
      return;
    }

    if(!this.isEntregaOk()){
      this.notificationsService.toastNotify("warn","Alerta!","A Entrega não pode ser superior à " +this.datePipe.transform(this.evento.dtLimiteEntrega,'dd/MM/yyyy')+
      " ou 15/08/2022 para pagamento anteciapado."
      
      )
      return;
    }

    if(!this.isDataPolpaOk()){
      this.notificationsService.toastNotify("warn","Alerta!","Pagamento não pode ser superior à 56 dias para polpa cítrica!")
      return;
    }

    console.log(this.produtos)
    if(!this.pedidoProdutos || this.pedidoProdutos.length==0){
      this.notificationsService.toastNotify("warn","Alerta!","O pedido não pode ser encerrado sem produtos.")
      return;
    }

    if(!this.formaPagamentoSelecionada){
      this.notificationsService.toastNotify("warn","Alerta!","O pedido não pode ser encerrado sem a forma de pagamento.")
      return;
    }

    this.confirmationService.confirm({
        message: 'Você tem certeza que deseja emitir esse pedido? Confira novamente o pedido, os preços podem ter mudado!',
        header: 'Confirmação',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.salvarPedido()
        },
        reject: () => {
          
        }
    });

}



  salvarPedido(){

   
    this.pedido = {} as PedidoEvento;

    this.pedido.guidPedido = this.guidPedido;
    this.pedido.idPessoa = this.pessoa.idPessoa.toString();
    this.pedido.idEndereco = this.endereco.idEndereco.toString();
    this.pedido.idPedidoStatus = '1';
    this.pedido.idPagamentoRegra=null;
    this.pedido.idusuario = this.vendedor?.idUsuario?.toString()??this.userService.getUserId().toString();
    this.pedido.dtPedido = new Date();
    this.pedido.dtEntrega = this.dataEntrega;

    if(this.temParcelas){
      this.pedido.dtPagtoIni=null;
      this.pedido.dtPrimeiraParcela=this.dataParcela;
      this.pedido.dtPagtoFim=null;
      this.pedido.vlParcela = this.valorParcela;
      this.pedido.qtParcelas = this.parcelaSelecionada.qtd;
      this.pedido.flParcelado=true;
    }else{
      
      this.pedido.dtPrimeiraParcela=null;
      this.pedido.dtPagtoFim=this.dataParcela;
      this.pedido.vlParcela = null;
      this.pedido.qtParcelas = 0;
      this.pedido.flParcelado=false;
      if(this.aVista){
        this.pedido.dtPagamentoFinal=new Date(this.dataEntrega);

        if(this.boleto){
          this.pedido.dtPagamentoFinal.setDate( this.pedido.dtPagamentoFinal.getDate() + 7 );
        }else if(this.antecipado){
          this.pedido.dtPagamentoFinal=new Date();
        }
        
      }else{
        this.pedido.dtPagamentoFinal= this.dataParcela;
      }
      

    }
    this.pedido.vlPagamentoFinal = this.valorTotalPedido;
    this.pedido.vlFrete = this.valorFrete;
    this.pedido.vlChapa = this.valorChapa;
    this.pedido.vlDesconto=this.valorDesconto;
    this.pedido.vlJuros = this.valorTotalPedido-this.valorTotalGeral;
    this.pedido.vlComissao = null;
    this.pedido.vlComissao = null;
    this.pedido.pesoCarga = this.pesoCarga;
    this.pedido.flCobrarFrete = this.endereco.distanciaKM==0?false:true;
    this.pedido.flDescontoEscala=false;
    this.pedido.obs=null;
    this.pedido.obsVendedor=this.obsVendedor;
    this.pedido.tipo="EVENTO";
    this.pedido.idEvento = Number(this.idEvento);
    this.pedido.idFornecedor = this.fornecedor.idFornecedor;
    this.pedido.idFormaPagamento = this.formaPagamentoSelecionada.idFormaPagamento.toString();
    this.pedido.txJurosParcela = this.taxaJuros;
    this.pedido.produtos = this.pedidoProdutos;
    this.pedido.vlPedido = this.valorTotalPedido;

    this.pedido.produtos = this.pedidoProdutos;
    this.pedido.vlSemEvento =this.valorNectar;

    this.pedido.vlEconomia = this.valorNectar-(this.valorTotalProdutos+this.valorChapa)+this.valorDesconto
    


    this.eventoService.addPedido(this.pedido).subscribe(
      (res) => {
        if (res) {
          console.log(res)
          this.notificationsService.toastNotify("success","Pedido!","O pedido "+res+" foi salvo com sucesso.")  
          
          
          this.router.navigate(['/evento-pedido-pdf/'+res])   
        }
      },
      err => {
        //this.notificationsService.toastNotify("error","Pedido!","Erro ao gerar pedido.")
        console.log("EventoPedidoDetalhe - Formas Pagamento");
        console.log(err);
      }
    );
    



  }



  PMT(ir, np, pv, fv, type, mesesPrimeiraParcela) {
    /*
     * ir   - interest rate per month
     * np   - number of periods (months)
     * pv   - present value
     * fv   - future value
     * type - when the payments are due:
     *        0: end of the period, e.g. end of month (default)
     *        1: beginning of period
     */
    console.log(ir)
    console.log(np)
    console.log(pv)
    console.log(fv)
    console.log(type)
    console.log(mesesPrimeiraParcela)
    var pmt, pvif;
  
    if(mesesPrimeiraParcela>0){
      let correcao =Math.pow(1 + ir, mesesPrimeiraParcela);
      pv = pv*correcao;
    }

    //console.log( type || (type = 0))
    fv || (fv = 0);
    type || (type = 0);
  
    if (ir === 0)
        return -(pv + fv)/np;
  
    pvif = Math.pow(1 + ir, np);
    pmt = - ir * (pv * pvif + fv) / (pvif - 1);
    console.log(pv*ir/(1-(1/(pvif))))
  
    if (type === 1)
        pmt /= (1 + ir);
  
    return pmt;
  }

  fv(ir,np,pv ){
    if(np>0){
      let correcao =Math.pow(1 + ir, np);
      return pv*correcao;

    }else{
      return pv;
    }
  }

}



